import { Event, events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { initialState } from "./initialState";
import { handleRequest } from "./retrieveResourceGroupsRequested";
import { handleSuccess } from "./retrieveResourceGroupsSucceeded";
import { handleFailure } from "./retrieveResourceGroupsFailed";
import { handleRemoveResourceGroup } from "./removeResourceGroupSucceeded";
import { handleAddResourceGroup } from "./addResourceGroup";
import { handleEditResourceGroup } from "./editResourceGroupSucceeded";
import { handleResourceAddition } from "./addResourceToResourceGroupSucceeded";
import { handleResourceRemoval } from "./removeResourceFromResourceGroupSucceeded";
import { handleEditResource } from "./editResource";
import { handleEditProjectResource } from "./editProjectResource";
import { handleRemoveResourceFromProjectSucceeded } from "./handleResourceFromProjectRemoval";
import { handleRemoveResourceFromPlanzoneSucceeded } from "./handleResourceFromPlanzoneRemoval";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { reduceResourceGroup } from "../../common/resourceGroup";

function propagateEvent(state = initialState, event: Event): State {
  return state.map((res) => ({
    ...res,
    groups: res.groups.map((group) => reduceResourceGroup(group, event)),
  }));
}

const reduceState = resetState(
  initialState,
  createStateReducer(
    initialState,
    {
      [events.retrieveResourceGroupsRequested]: handleRequest,
      [events.retrieveResourceGroupsSucceeded]: handleSuccess,
      [events.retrieveResourceGroupsFailed]: handleFailure,
      [events.removeResourceGroupSucceeded]: handleRemoveResourceGroup,
      [events.addResourceGroupSucceeded]: handleAddResourceGroup,
      [events.editResourceGroupSucceeded]: handleEditResourceGroup,
    },
    propagateEvent,
  ),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
